import { Button } from '../../../../components/Button/Button'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useZocksAuth } from '../../../../components/ScopedBlock/hooks'

interface CrossClientHeaderProps {
  executionId: string
}

export const CrossClientHeader: React.FC<CrossClientHeaderProps> = ({ executionId }) => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const fromTab = (state as { fromTab?: string } | null)?.fromTab

  const { hasScope } = useZocksAuth()
  const canSchedule = hasScope('**', 'schd_ccq:create', ['schd_ccq:admin'])

  const handleBackButtonClicked = () => {
    navigate(fromTab ? `/cross-client?tab=${encodeURIComponent(fromTab)}` : '/cross-client')
  }

  const handleScheduleClicked = () => {
    navigate(`/cross-client/executions/${executionId}/schedule`)
  }

  return (
    <div className='d-flex align-items-center justify-content-between w-100 pe-2'>
      <div className='zocks-pl-2.0'>
        <Button variant='link' className='back-button' onClick={handleBackButtonClicked}>
          <i className='bi bi-chevron-left' />
        </Button>
      </div>
      {canSchedule ? (
        <Button
          variant='header'
          className='cross-client-schedule-button d-flex align-items-center gap-2 bg-white zocks-border-0.5 zocks-border-color-gray-300'
          onClick={handleScheduleClicked}
        >
          <i className='bi bi-calendar2-plus' />
          <span className='paragraph-small medium'>Schedule query</span>
        </Button>
      ) : null}
    </div>
  )
}
